// extracted by mini-css-extract-plugin
export default {"heading":"Info_heading__ZhRgk","slogan":"Info_slogan__tIkEd"};